import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { timePickerInjectionKey as y } from "./interface.js";
import m from "./PanelCol.js";
import { getTimeUnits as h, getAmPm as $, time as f } from "./utils.js";
import N from "../../_internal/focus-detector/src/FocusDetector.js";
import P from "../../button/src/Button.js";
import p from "../../_internal/scrollbar/src/Scrollbar.js";
import { defineComponent as V, inject as g, computed as v, h as i } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as b } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const B = {
  actions: {
    type: Array,
    default: () => ["now", "confirm"]
  },
  showHour: {
    type: Boolean,
    default: !0
  },
  showMinute: {
    type: Boolean,
    default: !0
  },
  showSecond: {
    type: Boolean,
    default: !0
  },
  showPeriod: {
    type: Boolean,
    default: !0
  },
  isHourInvalid: Boolean,
  isMinuteInvalid: Boolean,
  isSecondInvalid: Boolean,
  isAmPmInvalid: Boolean,
  isValueInvalid: Boolean,
  hourValue: {
    type: Number,
    default: null
  },
  minuteValue: {
    type: Number,
    default: null
  },
  secondValue: {
    type: Number,
    default: null
  },
  amPmValue: {
    type: String,
    default: null
  },
  isHourDisabled: Function,
  isMinuteDisabled: Function,
  isSecondDisabled: Function,
  onHourClick: {
    type: Function,
    required: !0
  },
  onMinuteClick: {
    type: Function,
    required: !0
  },
  onSecondClick: {
    type: Function,
    required: !0
  },
  onAmPmClick: {
    type: Function,
    required: !0
  },
  onNowClick: Function,
  clearText: String,
  nowText: String,
  confirmText: String,
  transitionDisabled: Boolean,
  onClearClick: Function,
  onConfirmClick: Function,
  onFocusin: Function,
  onFocusout: Function,
  onFocusDetectorFocus: Function,
  onKeydown: Function,
  hours: [Number, Array],
  minutes: [Number, Array],
  seconds: [Number, Array],
  use12Hours: Boolean
}, T = V({
  name: "TimePickerPanel",
  props: B,
  setup(r) {
    const {
      mergedThemeRef: u,
      mergedClsPrefixRef: c
    } = g(y), d = v(() => {
      const {
        isHourDisabled: t,
        hours: s,
        use12Hours: o,
        amPmValue: n
      } = r;
      if (o) {
        const a = n != null ? n : $(Date.now());
        return h(f.hours, s, a).map((C) => {
          const k = Number(C), S = a === "pm" && k !== 12 ? k + 12 : k;
          return {
            label: C,
            value: S,
            disabled: t ? t(S) : !1
          };
        });
      } else
        return h(f.hours, s).map((a) => ({
          label: a,
          value: Number(a),
          disabled: t ? t(Number(a)) : !1
        }));
    }), e = v(() => {
      const {
        isMinuteDisabled: t,
        minutes: s
      } = r;
      return h(f.minutes, s).map((o) => ({
        label: o,
        value: Number(o),
        disabled: t ? t(Number(o), r.hourValue) : !1
      }));
    }), l = v(() => {
      const {
        isSecondDisabled: t,
        seconds: s
      } = r;
      return h(f.seconds, s).map((o) => ({
        label: o,
        value: Number(o),
        disabled: t ? t(Number(o), r.minuteValue, r.hourValue) : !1
      }));
    }), F = v(() => {
      const {
        isHourDisabled: t
      } = r;
      let s = !0, o = !0;
      for (let n = 0; n < 12; ++n)
        if (!(t != null && t(n))) {
          s = !1;
          break;
        }
      for (let n = 12; n < 24; ++n)
        if (!(t != null && t(n))) {
          o = !1;
          break;
        }
      return [{
        label: "AM",
        value: "am",
        disabled: s
      }, {
        label: "PM",
        value: "pm",
        disabled: o
      }];
    });
    return {
      mergedTheme: u,
      mergedClsPrefix: c,
      hours: d,
      minutes: e,
      seconds: l,
      amPm: F,
      hourScrollRef: b(null),
      minuteScrollRef: b(null),
      secondScrollRef: b(null),
      amPmScrollRef: b(null)
    };
  },
  render() {
    var r, u, c, d;
    const {
      mergedClsPrefix: e,
      mergedTheme: l
    } = this;
    return i("div", {
      tabindex: 0,
      class: `${e}-time-picker-panel`,
      onFocusin: this.onFocusin,
      onFocusout: this.onFocusout,
      onKeydown: this.onKeydown
    }, i("div", {
      class: `${e}-time-picker-cols`
    }, this.showHour ? i("div", {
      class: [`${e}-time-picker-col`, this.isHourInvalid && `${e}-time-picker-col--invalid`, this.transitionDisabled && `${e}-time-picker-col--transition-disabled`]
    }, i(p, {
      ref: "hourScrollRef",
      theme: l.peers.Scrollbar,
      themeOverrides: l.peerOverrides.Scrollbar
    }, {
      default: () => [i(m, {
        clsPrefix: e,
        data: this.hours,
        activeValue: this.hourValue,
        onItemClick: this.onHourClick
      }), i("div", {
        class: `${e}-time-picker-col__padding`
      })]
    })) : null, this.showMinute ? i("div", {
      class: [`${e}-time-picker-col`, this.transitionDisabled && `${e}-time-picker-col--transition-disabled`, this.isMinuteInvalid && `${e}-time-picker-col--invalid`]
    }, i(p, {
      ref: "minuteScrollRef",
      theme: l.peers.Scrollbar,
      themeOverrides: l.peerOverrides.Scrollbar
    }, {
      default: () => [i(m, {
        clsPrefix: e,
        data: this.minutes,
        activeValue: this.minuteValue,
        onItemClick: this.onMinuteClick
      }), i("div", {
        class: `${e}-time-picker-col__padding`
      })]
    })) : null, this.showSecond ? i("div", {
      class: [`${e}-time-picker-col`, this.isSecondInvalid && `${e}-time-picker-col--invalid`, this.transitionDisabled && `${e}-time-picker-col--transition-disabled`]
    }, i(p, {
      ref: "secondScrollRef",
      theme: l.peers.Scrollbar,
      themeOverrides: l.peerOverrides.Scrollbar
    }, {
      default: () => [i(m, {
        clsPrefix: e,
        data: this.seconds,
        activeValue: this.secondValue,
        onItemClick: this.onSecondClick
      }), i("div", {
        class: `${e}-time-picker-col__padding`
      })]
    })) : null, this.use12Hours ? i("div", {
      class: [`${e}-time-picker-col`, this.isAmPmInvalid && `${e}-time-picker-col--invalid`, this.transitionDisabled && `${e}-time-picker-col--transition-disabled`]
    }, i(p, {
      ref: "amPmScrollRef",
      theme: l.peers.Scrollbar,
      themeOverrides: l.peerOverrides.Scrollbar
    }, {
      default: () => [i(m, {
        clsPrefix: e,
        data: this.amPm,
        activeValue: this.amPmValue,
        onItemClick: this.onAmPmClick
      }), i("div", {
        class: `${e}-time-picker-col__padding`
      })]
    })) : null), !((r = this.actions) === null || r === void 0) && r.length ? i("div", {
      class: `${e}-time-picker-actions`
    }, !((u = this.actions) === null || u === void 0) && u.includes("clear") ? i(P, {
      theme: l.peers.Button,
      themeOverrides: l.peerOverrides.Button,
      size: "tiny",
      onClick: this.onClearClick
    }, {
      default: () => this.clearText
    }) : null, !((c = this.actions) === null || c === void 0) && c.includes("now") ? i(P, {
      size: "tiny",
      theme: l.peers.Button,
      themeOverrides: l.peerOverrides.Button,
      onClick: this.onNowClick
    }, {
      default: () => this.nowText
    }) : null, !((d = this.actions) === null || d === void 0) && d.includes("confirm") ? i(P, {
      size: "tiny",
      type: "primary",
      class: `${e}-time-picker-actions__confirm`,
      theme: l.peers.Button,
      themeOverrides: l.peerOverrides.Button,
      disabled: this.isValueInvalid,
      onClick: this.onConfirmClick
    }, {
      default: () => this.confirmText
    }) : null) : null, i(N, {
      onFocus: this.onFocusDetectorFocus
    }));
  }
});
export {
  T as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/time-picker/src/Panel.js
// module id = 1752
// module chunks = 67